import { useTranslation } from 'react-i18next';
import { Card } from '@/components/ui/card';

export function IssueLegend() {
  const { t } = useTranslation('clientImport');

  return (
    <Card padding="sm" className="flex flex-wrap items-center gap-4">
      <span className="text-xs font-bold uppercase tracking-wider text-zoomuted">
        {t('legend.title')}
      </span>
      <span className="flex items-center gap-2 text-sm text-zooindigo">
        <span className="w-3.5 h-3.5 rounded-sm bg-zooerrorbg border border-zooerrorborder" />
        {t('legend.error')}
      </span>
      <span className="flex items-center gap-2 text-sm text-zooindigo">
        <span className="w-3.5 h-3.5 rounded-sm bg-zoowarningbg border border-zoowarningtext" />
        {t('legend.warning')}
      </span>
      <span className="flex items-center gap-2 text-sm text-zooindigo">
        <span className="w-3.5 h-3.5 rounded-sm bg-zoowhite border border-zooborder" />
        {t('legend.clean')}
      </span>
    </Card>
  );
}
